// src/App.js (ou outro componente)
import React, { useState } from 'react';
import axios from 'axios';

const Teste = () => {
  const [fileUrl, setFileUrl] = useState('');

  const getFileUrl = async () => {
    try {
      const response = await axios.get('https://webhomol.meupgr.com.br/api/file-url/1001/aso/71502/ASO-71502.pdf', { responseType: 'blob' });
      const blob = new Blob([response.data], { type: response.headers['content-type'] });
      const url = window.URL.createObjectURL(blob);
      setFileUrl(url);
    } catch (error) {
      console.error('Error fetching file URL:', error);
    }
  };

  return (
    <div>
      <button onClick={getFileUrl}>Get File URL</button>
      {fileUrl && (
        <div>
          <a href={fileUrl} target="_blank" rel="noopener noreferrer">Download File</a>
        </div>
      )}
    </div>
  );
};

export default Teste;
